import React from 'react';

import { Table, cn } from 'twyne-new.ui';

import { TableResizeProvider } from '@Components/tableResize/context';
import { useInicializeTableResize } from '@Components/tableResize/hooks';

import Body from './Body';
import { Header } from './Header';
import NoContent from './NoContent';

const DefaultTableResizeContent = ({ columns, data, noDataIndication, rowClassName, keyField = 'id', className = '', rowWrapper, footer, sticky = true, fixedFistColumnOnScroll = false }) => {
  const { hadResized, onResize } = useInicializeTableResize({ columns })

  return <div className='relative'>
    <Table className={cn('w-full', hadResized && 'table-fixed')} containerClassName={className}>
      <Header
        columns={columns}
        sticky={sticky}
        fixedFistColumnOnScroll={fixedFistColumnOnScroll}
        onResize={onResize}
      />
      <Body
        data={data}
        columns={columns}
        rowClassName={rowClassName}
        keyField={keyField}
        rowWrapper={rowWrapper}
        fixedFistColumnOnScroll={fixedFistColumnOnScroll}
      />
      {footer}
    </Table>
    <NoContent data={data} noDataIndication={noDataIndication} />
  </div>
}

export default function DefaultTableResize(props) {
  return <TableResizeProvider>
    <DefaultTableResizeContent {...props} />
  </TableResizeProvider>
}
